module.exports = __webpack_public_path__ + "assets/d55660412b76e5c3458ea167efe720bd.mp3";